module.exports = __webpack_public_path__ + "static/img/05ok.870a546a.webp";